'use strict';

module.exports = function (column) {

  var sortAll = typeof this.opts.sortable == 'boolean' && this.opts.sortable;

  if (sortAll) return true;

  return this.opts.sortable.indexOf(column) > -1;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/sortable.js